"use client";

// Package Imports
import React from "react";
import Image from "next/image";
import Link from "next/link";
import classNames from "classnames";

// Style Imports
import styles from "./footer.module.scss";

// Custom Code Imports
import { strings } from '@/lib/data/site/strings';

export default function Footer({ cookieYesEnabled = false }: { cookieYesEnabled?: boolean }) {
  const getDate = () => {
    const date = new Date();
    return date.getFullYear();
  };

  return (
    <footer className={styles.footer} role="contentinfo">
      <div className={styles.footerTop}>
        <div className={styles.footerColumn}>
          <Link href="/">
            <Image
              src="/images/logo-white.svg"
              alt={strings.brandName}
              width={300}
              height={110}
              className={classNames(styles.logoFooter, styles.partysupplies)}
              priority
            />
          </Link>
        </div>
        <div className={styles.footerColumn}>
          <h4 className={styles.footerTitle}>
            <Link href="/bottle-service/">Bottle Service</Link>
          </h4>
          <ul className={styles.footerList}>
            <li><Link href="/bottle-service/sparklers/">Sparklers & Toppers</Link></li>
            <li><Link href="/bottle-service/bottle-presenters/">Bottle Presenters</Link></li>
            <li><Link href="/bottle-service/stickers/">Stickers</Link></li>
            <li><Link href="/bottle-service/trays/">Trays</Link></li>
          </ul>
        </div>
        <div className={styles.footerColumn}>
          <h4 className={styles.footerTitle}>
            <Link href="/party-supplies/">Party Supplies</Link>
          </h4>
          <ul className={styles.footerList}>
            <li><Link href="/party-supplies/party-kits/">Party Kits</Link></li>
            <li><Link href="/party-supplies/confetti-poppers/">Confetti Poppers</Link></li>
            <li><Link href="/party-supplies/ice-buckets/">Ice Buckets</Link></li>
          </ul>
        </div>
        <div className={styles.footerColumn}>
          <ul className={classNames(styles.footerList, styles.footerListFeatured)}>
            <li className={styles.footerTitle}><Link href="/menus-and-signs/">Menus & Signs</Link></li>
            <li className={styles.footerTitle}><Link href="/soda-syrups/">Soda Syrups</Link></li>
            <li className={styles.footerTitle}><Link href="/faq/">FAQ</Link></li>
            <li className={styles.footerTitle}><Link href="/about-us/">About Us</Link></li>
            <li className={styles.footerTitle}><Link href="/about-us/contact-us/">Contact Us</Link></li>
          </ul>
        </div>
        <div className={styles.footerColumn}>
          <ul className={classNames(styles.footerList, styles.footerListAccount)}>
            <li className={styles.footerTitle}><Link href="/my-account/">Login / Create an Account</Link></li>
            <li className={styles.footerTitle}><Link href="/cart/">View Cart</Link></li>
          </ul>
        </div>
      </div>

      <div className={styles.footerBottom}>
        <div className={styles.footerBottomInner}>
          <p>
            © {getDate()} {process.env.NEXT_PUBLIC_DEFAULT_MAP_PIN_TEXT}
            <br />
            Designed by the {" "}
            <a
              href="http://www.leetilford.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Lee Tilford Agency
            </a>{" "}
            •{" "}
            <a
              href="http://www.poweredbylta.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Powered by LTA
            </a>
          </p>
          <ul>
            <li>
              <Link href="/legal/terms-conditions/">Terms &amp; Conditions</Link>
            </li>
            <li>
              <Link href="/legal/privacy-policy/">Privacy Policy</Link>
            </li>
            <li>
              <Link href="/legal/accessibility-statement/">Our Accessibility Statement</Link>
            </li>
            <li>
              <Link href="/legal/cookie-policy/">Cookie Policy</Link>
            </li>
            <li>
              <Link href="/legal/sms-terms-privacy/">SMS Terms &amp; Privacy</Link>
            </li>
            {/* US state privacy laws (CCPA/CPRA, TDPSA) opt-out; reopens the CookieYes banner where the visitor can deny advertisement consent */}
            {/* Rendered only when a CookieYes key is configured for the channel, so the trigger never appears without the banner that backs it */}
            {cookieYesEnabled && (
              <li>
                <button type="button" onClick={() => window.revisitCkyConsent?.()}>
                  Do Not Sell or Share My Personal Information
                </button>
              </li>
            )}
          </ul>
        </div>
      </div>
    </footer >
  );
}
